<template>
  <div class="common-modal-wrap">
    <div
      :class="{
        'pc-modal-content': !isMobile,
        'mobile-modal-content': isMobile,
      }"
    >
      <div
        :class="{
          'pc-modal-header': !isMobile,
          'bg-gray-200 p-4 flex justify-between items-center': isMobile,
        }"
      >
        <h2 class="text-lg font-bold">{{ title }}</h2>
        <button @click="$emit('close')" class="text-gray-500">닫기</button>
      </div>

      <div class="flex-1 p-4 overflow-y-auto">
        <div v-if="isMobile">
          <div class="flex items-center space-x-4 relative">
            <input
              type="number"
              class="w-full p-2 border border-gray-300 rounded appearance-none text-right pe-10"
              placeholder="값 설정"
              v-model="percent"
            />
            <div class="common-input-suffix">
              <span>%</span>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="input-with-append">
            <input
              type="number"
              class="input-number"
              placeholder="값 설정"
              v-model="percent"
            />
            <button type="button" class="btn-no-hover">%</button>
          </div>
        </div>
      </div>

      <div class="p-4">
        <button
          @click="handleSubmit"
          class="bg-blue-500 text-white w-full py-2 rounded"
          v-bind:disabled="isLoading"
        >
          <div v-if="isLoading" class="flex justify-center">
            <VueSpinner size="20"></VueSpinner>
          </div>

          <span v-else>저장</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { VueSpinner } from "vue3-spinners";
import { mapActions, mapGetters } from "vuex";

const coreStore = "coreStore";
const stopStore = "stopStore";
const modalConfig = {
  stop: "전체 매수 중지 설정",
  sell: "강제 매도 설정",
};
export default {
  name: "ConfigModal",
  props: {
    modalType: String,
    forceSell: Object,
    forceStop: Object,
    isMobile: Boolean,
  },
  components: {
    VueSpinner,
  },
  emits: ["close"],
  data() {
    return {
      autoStopSeq: null,
      autoSellSeq: null,
      percent: "",
      isLoading: false,
      // 초기화
    };
  },
  created() {
    this.title = modalConfig[this.modalType];
  },
  mounted() {
    if (this.modalType == "stop" && this.forceStop != null) {
      this.percent = this.forceStop.triggerPercent;
      this.autoStopSeq = this.forceStop.autoStopSeq;
    } else if (this.modalType === "sell" && this.forceSell != null) {
      this.percent = this.forceSell.sellPercent;
      this.autoSellSeq = this.forceSell.autoSellSeq;
    }
  },
  unmounted() {
    this.percent = "";
    this.autoStopSeq = null;
    this.autoSellSeq = null;
  },
  computed: {
    // 현재 포지션 조회 (true : long, false: short)
    ...mapGetters(coreStore, ["GT_IS_LONG"]),
  },
  methods: {
    ...mapActions(stopStore, ["AT_SAVE_STOP", "AT_SAVE_SELL"]),
    /* 설정값 저장 */
    async handleSubmit() {
      if (!confirm("해당 값으로 저장하시겠습니까?")) return false;

      const configType = this.modalType;
      if (configType === "stop") {
        // 강제 매수 중지일 경우,
        await this.saveForceStop();
      } else {
        // 강제 매도 일경우,
        await this.saveForceSell();
      }

      this.$emit("close");
    },

    /* 강제 매수 중지 저장 (global) */
    async saveForceStop() {
      const position = this.GT_IS_LONG ? "LONG" : "SHORT";

      // 글로벌로 저장할때는 (전역 설정) symbol 이름을 따로 보내지 않는다.
      const actionPayload = {
        autoStopSeq: this.autoStopSeq,
        positionSide: position,
        triggerPercent: this.percent,
      };

      await this.AT_SAVE_STOP(actionPayload);
    },

    /* 강제 매도 저장 (global) */
    async saveForceSell() {
      const position = this.GT_IS_LONG ? "LONG" : "SHORT";

      // 글로벌로 저장할때는 (전역 설정) symbol 이름을 따로 보내지 않는다.
      const actionPayload = {
        autoSellSeq: this.autoSellSeq,
        positionSide: position,
        triggerPercent: this.percent,
      };
      await this.AT_SAVE_SELL(actionPayload);
    },
  },
};
</script>

<style scoped>
/* 스타일 */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
